import { render } from "./TextBlock.vue?vue&type=template&id=22af7831&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=22af7831&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22af7831"]])

export default __exports__